import { ApiAiReviewsUrls } from '@api/aiReviews/api.aiReviews.urls';
import { ApiAuthUrls } from '@api/auth/api.auth.urls';
import { ApiFilesUrls } from '@api/files/api.files.urls';
import { ApiFundsUrls } from '@api/funds/api.funds.urls';
import { ApiSubscriptionUrls } from '@api/subscription/api.subscription.urls';
import { ApiUsersUrls } from '@api/users/api.users.urls';

export const ApiUrls = {
  aiReviews: ApiAiReviewsUrls,
  auth: ApiAuthUrls,
  files: ApiFilesUrls,
  users: ApiUsersUrls,
  funds: ApiFundsUrls,
  subscription: ApiSubscriptionUrls,
};
